function debounce (func, delay = 500, immediate = false) {
  let timer = null;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    if (immediate && !timer) {
      func.apply(this, args);
    }
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export default {
  debounce
};



// WEBPACK FOOTER //
// ./src/utils/tools/_common.js